<div class="tab-items relative">
  <div class="flex justify-between h-full -ml-[16px] -mr-[16px] overflow-x-auto w-svw md:w-auto">
    <button (click)="changeSlide(-1)" class="block md:hidden nav btn btn-transparent bg-white pr-0">
      <svg-icon class="btn-icon ltr:block rtl:hidden" src="@assets/images/icons/chevron-left.svg"></svg-icon>
      <svg-icon class="btn-icon ltr:hidden rtl:block" src="@assets/images/icons/chevron-right.svg"></svg-icon>
    </button>

    <swiper-container #swiperContainer class="w-full max-w-full swiper flex flex-wrap text-center text-sm font-medium text-slate-500">
      <ng-container *ngIf="isPreviewCourse">
        <swiper-slide class="!w-auto block lg:hidden" id="0">
          <a [routerLink]="getLink(tabItems[0].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[0].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[0].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[0].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="1">
          <a [routerLink]="getLink(tabItems[1].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[1].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[1].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[1].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="2">
          <a [routerLink]="getLink(tabItems[2].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[2].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[2].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[2].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="3">
          <a [routerLink]="getLink(tabItems[3].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[3].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[3].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[3].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="4">
          <a [routerLink]="getLink(tabItems[4].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[4].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[4].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[4].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="5">
          <a [routerLink]="getLink(tabItems[5].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[5].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[5].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[5].title }}</a>
        </swiper-slide>
      </ng-container>
      <ng-container *ngIf="!isPreviewCourse">
        <swiper-slide class="!w-auto block lg:hidden" id="0">
          <a [routerLink]="getLink(tabItems[0].route)" [id]="'tabid_' + tabItems[0].id" class="inline-block border-b-2 px-6 py-3"
            [ngClass]="activeTab === tabItems[0].route ? 'border-slate-900' : 'border-transparent'">
            {{ tabItems[0].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="1">
          <a [routerLink]="getLink(tabItems[1].route)" [id]="'tabid_' + tabItems[1].id" class="inline-block border-b-2 px-6 py-3"
            [ngClass]="activeTab === tabItems[1].route ? 'border-slate-900' : 'border-transparent'">
            {{ tabItems[1].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="2">
          <a [routerLink]="getLink(tabItems[2].route)" [id]="'tabid_' + tabItems[2].id" class="inline-block border-b-2 px-6 py-3"
            [ngClass]="activeTab === tabItems[2].route ? 'border-slate-900' : 'border-transparent'">
            {{ tabItems[2].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="3">
          <a [routerLink]="getLink(tabItems[3].route)" [id]="'tabid_' + tabItems[3].id"
            class="inline-block border-b-2 px-6 py-3"
            [ngClass]="activeTab === tabItems[3].route ? 'border-slate-900' : 'border-transparent'">
            {{ tabItems[3].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="4">
          <a [routerLink]="getLink(tabItems[4].route)" [id]="'tabid_' + tabItems[4].id"
            class="inline-block border-b-2 px-6 py-3"
            [ngClass]="activeTab === tabItems[4].route ? 'border-slate-900' : 'border-transparent'">
            {{ tabItems[4].title }}</a>
        </swiper-slide>
        <swiper-slide class="!w-auto" id="5">
          <a [routerLink]="getLink(tabItems[5].route)" [id]="'tabid_' + tabItems[5].id"
            class="inline-block border-b-2 px-6 py-3"
            [ngClass]="activeTab === tabItems[5].route ? 'border-slate-900' : 'border-transparent'">
            {{ tabItems[5].title }}</a>
        </swiper-slide>
      </ng-container>
    </swiper-container>

    <!-- <swiper class="w-full" [config]="categorySlider">
      <ng-template swiperSlide class="!w-auto"> -->
        <!-- <li *ngFor="let item of tabItems; let i = index">
      <a
        [routerLink]="getLink(item.route)"
        [id]="'tabid_' + item.id"
        class="inline-block border-b-2 px-6 py-3"
        [ngClass]="activeTab === item.route ? 'border-slate-900' : 'border-transparent'"
        >{{ item.title }}</a
      >
    </li> -->
        <!-- <ul *ngIf="isPreviewCourse" class="flex flex-wrap text-center text-sm font-medium text-slate-500">
          <li class="block lg:hidden">
            <a [routerLink]="getLink(tabItems[0].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[0].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[0].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[0].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[1].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[1].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[1].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[1].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[2].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[2].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[2].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[2].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[3].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[3].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[3].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[3].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[4].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[4].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[4].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[4].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[5].route)" [queryParams]="queryParams" [replaceUrl]="true" [id]="'tabid_' + tabItems[5].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[5].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[5].title }}</a>
          </li>
        </ul>
        <ul *ngIf="!isPreviewCourse" class="flex flex-wrap text-center text-sm font-medium text-slate-500">
          <li class="block lg:hidden">
            <a [routerLink]="getLink(tabItems[0].route)" [id]="'tabid_' + tabItems[0].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[0].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[0].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[1].route)" [id]="'tabid_' + tabItems[1].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[1].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[1].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[2].route)" [id]="'tabid_' + tabItems[2].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[2].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[2].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[3].route)" [id]="'tabid_' + tabItems[3].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[3].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[3].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[4].route)" [id]="'tabid_' + tabItems[4].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[4].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[4].title }}</a>
          </li>
          <li>
            <a [routerLink]="getLink(tabItems[5].route)" [id]="'tabid_' + tabItems[5].id"
              class="inline-block border-b-2 px-6 py-3"
              [ngClass]="activeTab === tabItems[5].route ? 'border-slate-900' : 'border-transparent'">
              {{ tabItems[5].title }}</a>
          </li>
        </ul> -->
      <!-- </ng-template>
    </swiper> -->
    <button (click)="changeSlide(1)" class="block md:hidden nav btn btn-transparent bg-white ps-0">
      <svg-icon class="btn-icon ltr:block rtl:hidden" src="@assets/images/icons/chevron-right.svg"></svg-icon>
      <svg-icon class="btn-icon ltr:hidden rtl:block" src="@assets/images/icons/chevron-left.svg"></svg-icon>
    </button>
  </div>
</div>
